import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import type { VolumePage } from '../data/volumePages';
type PageLightboxProps = {
  page: VolumePage | null;
  onClose: () => void;
};
export function PageLightbox({
  page,
  onClose
}: PageLightboxProps) {
  const closeRef = useRef<HTMLButtonElement>(null);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (!page) return;
    const previous = document.activeElement as HTMLElement | null;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = overflow;
      previous?.focus();
    };
  }, [page, onClose]);
  return <AnimatePresence data-id="element-172" data-mp="108kgrnpnzf1t">
      {page && <motion.div role="dialog" aria-modal="true" aria-label={page.label} className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} onClick={onClose} data-id="element-173" data-mp="107skeao8tdah">
          <button ref={closeRef} type="button" onClick={onClose} aria-label="Close page preview" className="absolute right-4 top-4 flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white transition-colors duration-150 hover:bg-white/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber" data-id="element-174" data-mp="hjdsll63pv8m">
            <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-175" data-mp="3uwh8o8hjcyr8" />
          </button>
          <motion.img src={page.src} alt={page.alt} onClick={e => e.stopPropagation()} className="max-h-[90vh] w-auto max-w-full rounded-xl border border-white/10 object-contain" initial={reduceMotion ? false : {
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-176" data-mp="2s4x4vfipfnk" />
        </motion.div>}
    </AnimatePresence>;
}